import { dayInTZ, EVENT_DATETIME_FORMAT, eventDisplayName } from 'src/components/helpers';

const EventHeading = ({ name, date, align = 'center' }) => {
  if (!name && !date) return null;

  return (
    <>
      {name ? <h3 style={{ textAlign: align, margin: 0 }}>{eventDisplayName(name)}</h3> : null}
      {date ? (
        <p
          style={{
            textAlign: align,
            padding: '12px 0 8px',
            margin: 0,
            fontSize: '24px',
          }}
        >
          <strong>{dayInTZ(date, EVENT_DATETIME_FORMAT)}</strong>
        </p>
      ) : null}
    </>
  );
};

export default EventHeading;
